import { APPLICATION_MAP } from '@core/constants/application.constants'

export const getAppName = (application: string) => APPLICATION_MAP[application] || application
